import { render, staticRenderFns } from "./TireFitmentVehicles.vue?vue&type=template&id=1df71076"
import script from "./TireFitmentVehicles.vue?vue&type=script&lang=ts"
export * from "./TireFitmentVehicles.vue?vue&type=script&lang=ts"
import style0 from "./TireFitmentVehicles.vue?vue&type=style&index=0&id=1df71076&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports